'use client';

import { useApp } from '@/forApp/states/appState/appState';
import type { ExtendedServicePage } from '@/forApp/types/Service';
import Button from '@/shared/Buttons/Button';
import ImageWithLoader from '@/shared/Image/ImageWithLoader';

import styles from './styles.module.css';

type ServiceMainBannerProps = {
  serviceItem: ExtendedServicePage;
};

export const ServiceMainBanner: React.FC<ServiceMainBannerProps> = ({
  serviceItem,
}) => {
  const { addModal, isMobile } = useApp();
  const onButtonClick = () => {
    addModal({
      name: 'ConsultationModal',
      title: 'Получить консультацию',
      from: '',
    });
  };

  return (
    <div className={styles.banner}>
      <div>
        <div className={styles.content}>
          <p>{serviceItem.detail_text}</p>
          <Button
            onClick={onButtonClick}
            aria-describedby="consultation-title"
            text={'Получить консультацию'}
            color={'dark'}
            className={styles.btnMain}
          />
        </div>
        <div>
          <h5 className={styles.cardsTitle}>
            {serviceItem.service_cards_title}
          </h5>
          <div className={styles.cardsWrapper}>
            {serviceItem.service_cards.map((card) => (
              <div key={card.slug} className={styles.card}>
                <h6>{card.title}</h6>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.imageWrapper}>
        {isMobile ? (
          <ImageWithLoader
            src={serviceItem.detail_image_path}
            alt={serviceItem.title}
            fill
            objectFit={'contain'}
            sizes={'100vw'}
            transparent
            className={styles.imageFill}
          />
        ) : (
          <ImageWithLoader
            src={serviceItem.detail_image_path}
            alt={serviceItem.title}
            width={480}
            height={300}
            objectFit={'contain'}
          />
        )}
      </div>
    </div>
  );
};
